/* eslint-disable no-unused-vars */
import { memo } from 'react';
import { Excluded, Pause, Start } from 'assets/icons';
import { CustomTooltip2, CustomTooltip } from 'components';

const getStatusIcon = {
  included: Start,
  excluded: Pause,
  excludedPublisher: Excluded,
};

const getStatusToolTip = {
  0: Eligible,
  1: Stopped,
  2: Running,
  3: LearningMode,
  4: NotAvailableMsg,
  5: InsufficientBid,
  6: NotAvailableMsg,
  7: LowImpressions,
  8: AverageImpressions,
  9: Running,
  10: Running,
  11: ExcludedPublisher,
};

const StatusComponent = (props) => {
  const { appStatus, pb_status_id, recommended_bid, saved_min_bid } = props;

  const StatusIcon = getStatusIcon[appStatus];
  const ToolTipContent =
    appStatus === 'excludedPublisher' ? getStatusToolTip[11] : getStatusToolTip[pb_status_id];
  return (
    <div>
      <CustomTooltip2
        content={<StatusIcon />}
        text={
          <ToolTipContent
            pb_status_id={pb_status_id}
            recommended_bid={recommended_bid}
            saved_min_bid={saved_min_bid}
          />
        }
      />
    </div>
  );
};

export const AppStatus = memo(StatusComponent);

function Eligible() {
  return <p>Eligible</p>;
}

function ExcludedPublisher() {
  return <p>Excluded in all campaigns</p>;
}

function Stopped() {
  return <p>Stopped</p>;
}

function Running({ pb_status_id, recommended_bid, saved_min_bid }) {
  if (pb_status_id === 2 || pb_status_id === 10) {
    return <p>Running</p>;
  }
  if (pb_status_id === 9) {
    return (
      <p>
        Running suggested bid for <br /> reaching first position ${recommended_bid}{' '}
      </p>
    );
  }
}
function LearningMode() {
  return <p>Learning mode</p>;
}

function NotAvailableMsg({ pb_status_id }) {
  if (pb_status_id === 4) {
    return (
      <p>
        Not available for this campaign,
        <br /> contact your account manager{' '}
      </p>
    );
  }

  return (
    <p>
      Not available for this campaign <br /> due to low conversion
    </p>
  );
}

function InsufficientBid({ pb_status_id, recommended_bid, saved_min_bid }) {
  return (
    <p>
      Insufficient bid - <br />
      Minimum bid is ${recommended_bid}
    </p>
  );
}

function LowImpressions({ pb_status_id, recommended_bid, saved_min_bid }) {
  return (
    <p>
      Low volume of impressions - <br /> suggested bid is ${recommended_bid}{' '}
    </p>
  );
}

function AverageImpressions({ pb_status_id, recommended_bid, saved_min_bid }) {
  return (
    <p>
      Average volume of impressions - <br /> suggested bid is ${recommended_bid}{' '}
    </p>
  );
}
